import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInternetSearchSettingsState {
  numSearchResults: number;
  searchType: string;
  searchWhen: string;
}

const initialState: IInternetSearchSettingsState = {
  numSearchResults: 3,
  searchType: "web",
  searchWhen: "",
};

const internetSearchSettingsSlice = createSlice({
  name: 'internet-search',
  initialState,
  reducers: {
    updateInternetSearchSettings(
      state,
      action: PayloadAction<Partial<IInternetSearchSettingsState>>
    ) {
      return { ...state, ...action.payload };
    },
    resetInternetSearchSettings() {
      return initialState;
    },
  },
});

export const { updateInternetSearchSettings, resetInternetSearchSettings } = internetSearchSettingsSlice.actions;
export default internetSearchSettingsSlice.reducer;
